// extracted by mini-css-extract-plugin
export default {"successBackground":"dK9d5pYGOQTA4jmd948b"};